import React, { Dispatch, useEffect, useState } from 'react'
import Form from 'react-bootstrap/Form'

import { DeviceKeyMappingInfo } from '../../redux/reducers/initialState'

type KeyMappingUploadProps = {
  setUploadData: Dispatch<React.SetStateAction<DeviceKeyMappingInfo>>
  setFormReady: Dispatch<React.SetStateAction<boolean>>
}

const KeyMappingUpload = ({
  setUploadData,
  setFormReady,
}: KeyMappingUploadProps) => {
  useEffect(() => {
    setFormReady(false)
  }, [])

  const [fileLabel, setFileLabel] = useState('Choose *.json file...')
  const [status, setStatus]: any = useState('')

  const handleBrowse = (event) => {
    const file = event.target.files[0]
    setFileLabel(file.name)
    const fileReader = new FileReader()

    fileReader.readAsText(file)
    fileReader.onload = function (event: any) {
      const fileContent: any = event.target.result

      try {
        const data = JSON.parse(fileContent)
        const keyMappingCount = Object.keys(data).length
        if (keyMappingCount == 0)
          throw new Error(
            'Please upload a JSON array file with at least 1 permission entity. Refer to documentation for examples.',
          )
        setStatus(
          <>
            <p className="text-success font-weight-bold responsive-font">
              Found {keyMappingCount} permission{keyMappingCount > 1 && 's'}.
            </p>
            <p className="responsive-font">Ready to upload.</p>
          </>,
        )
        setUploadData(data)
        setFormReady(true)
      } catch (error) {
        console.warn(error)
        setStatus(
          <>
            <p className="text-danger font-weight-bold responsive-font">
              Please upload a valid .json file
            </p>
          </>,
        )
        setFormReady(false)
      }
    }
  }

  return (
    <>
      <Form.Control
        id="upload-mapping-file"
        title={fileLabel}
        accept="application/json"
        onChange={handleBrowse}
        type="file"
        className="responsive-font"
      />
      <div className="responsive-font mt-4 text-center">{status}</div>
    </>
  )
}

export default KeyMappingUpload
